import React from 'react';
import SdkLoginModal from 'rev.sdk.js/Components/LoginModal';
import * as CustomLogin from '../../Utils/CustomLogin';

function LoginModal(props) {
  return <SdkLoginModal {...CustomLogin.getExtraLoginModalProps()} />;
}

export default LoginModal;
